export type OrderLine = {
  id: string;
  medicineId: number;
  productName: string;
  quantity: number;
  unitPrice: number;
  total: number;
};

export type Order = {
  id: string;
  clientDni: string;
  clientName: string;
  address: string;
  reference: string;
  lines: OrderLine[];
  total: number;
  createdAt: string;
};

export function newOrderId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `ord-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function newLineId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `line-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function buildInitialOrders(): Order[] {
  const names = ['Maria Lopez', 'Juan Perez', 'Ana Torres', 'Carlos Ruiz', 'Lucia Vega'];
  const now = Date.now();
  return Array.from({ length: 28 }, (_, i) => {
    const dayOffset = i % 14;
    const createdAt = new Date(now - dayOffset * 86400000 - i * 3600000).toISOString();
    const dni = i % 4 === 0 ? '' : `${String(40000000 + i).slice(0, 8)}`;
    const variedQty = 1 + (i % 4);
    const variedUnit = 8 + (i % 6);
    const lineTotal = variedQty * variedUnit;
    return {
      id: `seed-${i + 1}`,
      clientDni: dni,
      clientName: `${names[i % names.length]} ${i > 4 ? i : ''}`.trim(),
      address: `Av. Ejemplo ${i + 1}, Lima`,
      reference: `Porton ${(i % 5) + 1}`,
      lines: [
        {
          id: `seed-line-${i}`,
          medicineId: 1,
          productName: 'Medicamento 1',
          quantity: variedQty,
          unitPrice: variedUnit,
          total: lineTotal,
        },
      ],
      total: lineTotal,
      createdAt,
    };
  });
}

export function formatOrderDate(iso: string): string {
  try {
    return new Date(iso).toLocaleString('es-PE', {
      dateStyle: 'short',
      timeStyle: 'short',
    });
  } catch {
    return iso;
  }
}

export function orderMatchesLocalDate(iso: string, filterYyyyMmDd: string): boolean {
  if (!filterYyyyMmDd.trim()) {
    return true;
  }
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}` === filterYyyyMmDd;
}
